import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  public production = true;

  public api = {
    url: '',
    client_id: 0,
    client_secret: '',
    version: 'v1',
    salon_id: null,
  };

  public firebase = {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }

  public test = '';
  
  public settings = {
    salon: {
      salon_logo: '',
      salon_banner: '',
      salon_name: ''
    },
    deposit: {},
    availability: {},
    app: {
      home_page_title: '',
      home_page_subtitle: '',
      has_about_us_page: '',
      has_gallery_page: '',
      colour: '',
      default_image: '',
      seo_default_title: '',
      seo_default_description: '',
      seo_default_keywords: '',
    },
    pages: {}
  };
}
